module.exports = __webpack_public_path__ + "img/lending-works-stacked-logo.e0a8263e.png";